import React, { memo } from "react";
import styled from "styled-components";
import { ISlotIcons } from "../../../types";
import { RoundedIcon } from "../../rounded-icon/rounded-icon";

const SlotIconsGroup = styled.div`
  display: flex;
  position: absolute;
  height: 14px;
  top: -6px;
  right: 0;
`;

const SlotIconsWrapper = (props: { icons: ISlotIcons }) => {
  return (
    <SlotIconsGroup>
      {props.icons.hasWaitingList ? (
        <RoundedIcon icon="waiting" position="tag" />
      ) : (
        ""
      )}
      {props.icons.hasOffer ? (
        <RoundedIcon icon="flash-on-icon" position="tag" />
      ) : (
        ""
      )}
      {props.icons.hasPrepayment ? (
        <RoundedIcon icon="payment-icon" position="tag" />
      ) : (
        ""
      )}
    </SlotIconsGroup>
  );
};
export const SlotIcons = memo(SlotIconsWrapper);
